export default (types, url, method = 'get', data, meta) => ({
  [`type${Array.isArray(types) ? 's' : ''}`]: types,
  payload: { request: { url, method, data } },
  meta,
});
